import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
const FETCH_INBOXES = 'FETCH_INBOXES';
export const fetchInboxActionTypes = createAsyncActionTypes(FETCH_INBOXES);
export const SET_CURRENT_INBOX = 'SET_CURRENT_INBOX';